module.exports = __webpack_public_path__ + "static/media/unCheckedBox.72ac9a54.svg";